import type { BusinessPhoto, BusinessPhotoCheckIn } from '@/api/endpoints/businesses';
import type { PhotoCaption, ViewerPhoto } from '@/components/display/image-viewer';

// Same label the activity card uses for a deleted account's anonymized content.
const SENTINEL_AUTHOR_NAME = 'Flavrly User';

/**
 * Lightbox caption for a business photo. The business name is left out: the
 * viewer is opened from that business's own screens.
 */
function captionFromCheckIn(checkIn: BusinessPhotoCheckIn): PhotoCaption {
  const { user, rating } = checkIn;
  const author = user.isSentinel
    ? { name: SENTINEL_AUTHOR_NAME, avatarUrl: null }
    : { name: user.displayName || user.username || 'Someone', avatarUrl: user.avatarUrl };

  return {
    checkInId: checkIn.id,
    ...(checkIn.menuItemName ? { dishName: checkIn.menuItemName } : {}),
    author,
    ...(checkIn.occurredAt ? { createdAt: checkIn.occurredAt } : {}),
    ...(rating ? { ratingLabel: rating.label, ratingKey: rating.key } : {}),
  };
}

/**
 * Business photos -> lightbox photos, each captioned with the check-in it came
 * from (author, dish, rating, time) and linked to that check-in.
 */
export function toBusinessViewerPhotos(photos: BusinessPhoto[]): ViewerPhoto[] {
  return photos.map(({ checkIn, ...photo }) =>
    checkIn ? { ...photo, caption: captionFromCheckIn(checkIn) } : photo
  );
}
